module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    class: {
      "is-fixed": _vm.fixed, "has-shadow": _vm.fixed
    }
  }, [_c('div', {
    staticClass: "header__logo"
  }, [_c('a', {
    staticClass: "header__logo--anchor",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "header__logo--image",
    attrs: {
      "src": "static/img/logo.svg",
      "alt": _vm.$lang.altimg.logo,
      "width": "150",
      "height": "65"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header__box"
  }, [(_vm.fixed) ? _c('div', {
    staticClass: "header__box--search header__search"
  }, [_c('search-form')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header__box--font header__font",
    class: {
      'is-active': _vm.isActiveFont, 'is-bigger-font': _vm.isFontSet
    },
    on: {
      "click": _vm.toggleFont
    }
  }, [_c('a', {
    staticClass: "header__font--select",
    attrs: {
      "href": "",
      "title": _vm.$lang.header.font
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('span', {
    staticClass: "onp-font"
  })]), _vm._v(" "), _c('div', {
    staticClass: "header__font--dropdown header__dropdown"
  }, _vm._l((_vm.$lang.fonts.name), function(key, value) {
    return _c('a', {
      staticClass: "header__dropdown--item",
      class: {
        'is-active': _vm.fontSize == value
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setFont(value)
        }
      }
    }, [_c('span', {
      staticClass: "header__font--symbol"
    }, [_vm._v("\n            A\n            "), (value == 'medium') ? _c('sup', [_vm._v("+")]) : _vm._e(), _vm._v(" "), (value == 'big') ? _c('sup', [_vm._v("++")]) : _vm._e()]), _vm._v("\n          " + _vm._s(key) + "\n        ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "header__box--lang header__lang",
    class: {
      'is-active': _vm.isActiveLang
    },
    on: {
      "click": _vm.toggleLang
    }
  }, [_c('a', {
    staticClass: "header__lang--select",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.language.toUpperCase()) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "header__lang--dropdown header__dropdown"
  }, _vm._l((_vm.$langs), function(lang) {
    return _c('a', {
      staticClass: "header__dropdown--item",
      class: {
        'is-active': _vm.isActiveLangClass(lang)
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setLang(lang)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.langs[lang]))])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3afb8986"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Header.vue
// module id = 335
// module chunks = 1